<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="captionm">Sketch Map of Babur’s World</p>
<p class="image"><img alt="Images" src="images/fig_v.jpg"/></p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="captionm">Samarkand</p>
<p class="image"><img alt="Images" src="images/fig_vi.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?66f90fb6